import { createBookmarkPayload, createBookmarkPlayerData } from '../../factories';
import { KalturaBookmark, KalturaBookmarkPlayerData } from '../../objects';
import { addBookmark as requestAddBookmark } from '../../services';

export type AddBookmarkArgs = {
  bookmark: Omit<KalturaBookmark, 'objectType' | 'playerData'>;
  playerData: Omit<KalturaBookmarkPlayerData, 'objectType'>;
};

export async function addBookmark({ bookmark, playerData }: AddBookmarkArgs) {
  await requestAddBookmark({
    bookmark: {
      ...createBookmarkPayload({
        ...bookmark,
        playerData: createBookmarkPlayerData(playerData),
      }),
    },
  });
}
